export default {
  getTableCache: state => (tableKey, cacheKey) => state.tables[tableKey]?.[cacheKey] || null,
}
